<template>
  <div class="sourceRecordHeat">
    <div>
      <li
        style="display: block;color: #000000;font-family: dfyuanstd-w5, dfyuanstd-w3;font-size: 1rem;"
      >
        生產重量
      </li>
      <commonRuncardTable
        :workID="workID"
        :runcardItem="sourceData[userSelectCode].runcardItem"
        :reason="sourceData[userSelectCode].reason"
        :modStatus="modStatus"
      />
    </div>
    <div>
      <li
        style="display: block;color: #000000;font-family: dfyuanstd-w5, dfyuanstd-w3;font-size: 1rem;"
      >
        總生產時間
      </li>
      <commonTotalProduceTable
        :processID="processID"
        :totalProduceTimeItem="sourceData[userSelectCode].totalProduceTimeItem"
        :reason="sourceData[userSelectCode].reason"
        :modStatus="modStatus"
      />
    </div>
  </div>
</template>

<script>
import commonRuncardTable from "@/components/orderManagement/table/commonRuncardTable.vue";
import commonTotalProduceTable from "@/components/orderManagement/table/commonTotalProduceTable.vue";
export default {
  name: "sourceRecordHeat",
  props: {
    userSelectCode: {
      type: Number,
      default: 0
    },
    workID: {
      type: String
    },
    processID: {
      type: String
    },
    sourceData: {
      type: Array,
      default: [
        {
          runcardItem: [],
          totalProduceTimeItem: [],
          reason: []
        }
      ]
    },
    modStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // userSelectCode: 0
    };
  },
  created: function() {},
  mounted: function() {},
  components: {
    commonRuncardTable,
    commonTotalProduceTable
  },
  watch: {},
  computed: {},
  methods: {
    onClick() {}
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/orderManagement/sourceRecord/sourceRecordHeat.vue